// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:02:04

export default {
  "id": "tangled-snakes-sort-puzzle",
  "slug": "tangled-snakes-sort-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8675564b513d4b64951833d0954cd0e8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8675564b513d4b64951833d0954cd0e8/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tangled Snakes - Sort Puzzle",
      "description": "Untangle all the tangled snakes in this fun and satisfying puzzle game!\n\nTangled Snakes – Sort Puzzle is a relaxing yet challenging brain teaser where you must sort and free the snakes from their tangled mess. Strategically move them in the correct order to clear each level and put your problem-solving skills to the test! Can you untangle them all?\n\nFeatures:\nSimple & intuitive controls!\nMind-teasing gameplay!\nHundreds of unique levels!\nEndless fun for all ages!",
      "instructions": "Easy tap and sort mechanic. Tap to move the snake in the correct order and beware of traps and obstacles to clear the level.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "colorful",
        "snake",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "错综蛇形 - 排序谜题",
      "description": "解开所有纠缠在一起的蛇，在这个有趣且令人满足的益智游戏中！\n\n《纠缠蛇 - 分类谜题》是一款轻松却又具有挑战性的脑力游戏，你必须整理并释放蛇从它们的纠缠中。策略性地移动它们到正确的顺序，通过每个关卡，并测试你的解决问题的能力！你能解开它们吗？\n\n特点：\n简单直观的操作！\n令人脑力激荡的游戏体验！\n数百个独特的关卡！\n适合所有年龄段的无限乐趣！",
      "instructions": "简单点击排序机制。点击移动蛇到正确的顺序，小心陷阱和障碍物，以清除关卡。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "多彩",
        "蛇",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "纏繞蛇 - 排序謎題",
      "description": "解開所有纏繞的蛇，享受這款有趣且令人滿足的益智遊戲！\n\n纏繞蛇 – 整理益智遊戲是一款令人放鬆但又挑戰的腦力遊戲，您必須整理並釋放蛇從纏繞的亂狀。策略性地移動它們到正確的順序，通過每個關卡，並測試您的問題解決能力！您能將它們全部解開嗎？\n\n特色：\n簡單直觀的操作！\n令人著迷的遊戲體驗！\n數百個獨特關卡！\n各個年齡層都能享受無盡的樂趣！",
      "instructions": "簡單點擊並排序機制。點擊移動蛇到正確順序，並小心陷阱和障礙以通過關卡。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "colorful: 多彩的\n snake: 蠍子\n sorting: 排序"
      ]
    },
    "zh-HK": {
      "title": "纏繞蛇 - 排序謎題",
      "description": "解開所有纏結的蛇，享受這款有趣且令人滿足的謎題遊戲！\n\n纏結蛇—排序謎題是一款輕鬆又挑戰的腦力遊戲，你必須將蛇從纏結的雜亂中分類並解放。策略性地將它們移動到正確的順序，通過每個關卡，並考验你的問題解決能力！你能解開所有纏結嗎？\n\n特色：\n簡單直觀的操作！\n挑戰心智的遊戲體驗！\n數百個獨特關卡！\n適合所有年齡層的無窮樂趣！",
      "instructions": "輕鬆點擊及排序機制。點擊移動蛇至正確順序，並注意陷阱及障礙物以清關等級。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "五彩蛇",
        "排序"
      ]
    },
    "ja": {
      "title": "乱れられた蛇 - ソートパズル",
      "description": "この楽しい満足感のあるパズルゲームで絡まった蛇を解き放ちましょう！\n\nTangled Snakes – Sort Puzzleは、リラックスしながらも挑戦的な脳トレゲームで、絡まった蛇を整え、解放する必要があります。戦略的に蛇を正しい順番に動かして、レベルをクリアし、問題解決スキルを試してみましょう！全部解けるでしょうか？\n\n特徴：\nシンプルで直感的な操作！\n頭を悩ます遊び方！\n数百のユニークなレベル！\n全世代に楽しめる無限の楽しみ！",
      "instructions": "簡単なタップと並べ替えメカニクス。正しい順番に蛇を動かすためにタップし、トラップや障害物に注意してレベルをクリアしてください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "カラフル",
        "スネーク",
        "ソート"
      ]
    },
    "ko": {
      "title": "활자 뱀 - 정렬 퍼즐",
      "description": "이 재미있고 만족스러운 패uzzle 게임에서 얽힌 파이프를 모두 풀어주세요!\n\nTangled Snakes – Sort Puzzle는 여러분이 얽힌 혼란에서 파이프를 정리하고 풀어내는 쉽고 직관적인脑筋急转弯 게임입니다. 전략적으로 이동하여 각 레벨을 클리어하고 문제 해결 능력을 테스트하세요! 모두를 풀어낼 수 있을까요?\n\n기능:\n간단하고 직관적인 조작!\n뇌를 자극하는 게임플레이!\n数百의 독특한 레벨!\n모든 연령대에 끊임없는 재미!",
      "instructions": "쉽게 탭하고 정렬하는 메커니즘. 탭하여 뱀을 올바른 순서로 이동시키고, 장애물과 은신처를 피하여 레벨을 클리어하세요.",
      "genres": [
        "캐주얼",
        "پازل"
      ],
      "tags": [
        "色彩豊かな",
        "蛇",
        "並べ替え"
      ]
    },
    "fr": {
      "title": "Tangled Snakes - Puzzle de Classifications",
      "description": "Détendez-vous et challenges avec ce puzzle amusant et satisfaisant où vous devez dénouer les serpents enchevêtrés !\n\nTangled Snakes – Sort Puzzle est un jeu de cérébral apaisant mais délicat où vous devez trier et libérer les serpents de leur chaos enchevêtré. Déplacez-les stratégiquement dans l'ordre correct pour passer chaque niveau et mettez vos compétences de résolution de problèmes à l'épreuve ! Pouvez-vous tous les dénouer ?\n\nFonctionnalités :\nContrôle simple et intuitif !\nJeu intellectuellement stimulant !\nCentaines de niveaux uniques !\nDivertissement infini pour tous les âges !",
      "instructions": "Mécanique simple de tapoter et de classer. Tapotez pour déplacer le serpent dans l'ordre correct et soyez prudent des pièges et des obstacles pour passer le niveau.",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "coloré",
        "serpent",
        "trier"
      ]
    }
  }
};
